import {createSelector} from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.customerPreJourneyInfo);
export const getPreJourneyInfo = createSelector(getState, ({preJourneyInfo}) => preJourneyInfo);
export const getAvailabilities = createSelector(getState, ({availabilities}) => availabilities);
export const getMobility = createSelector(getPreJourneyInfo, (PreJourneyInfo = {}) => PreJourneyInfo.mobility);
export const getType = createSelector(getState, ({type}) => type);
export const getUntrustedVinwOffering = createSelector(getPreJourneyInfo, (preJourneyInfo = {}) => preJourneyInfo.untrustedVinwOffering);



// WEBPACK FOOTER //
// ./src/selectors/customerPreJourneyInfo.js